import OrganizationRecipientForm from 'features/OrgRecipient/OrganizationRecipientForm';
import React from 'react';

const OrgRecipientsFormView = () => {
  return (
    <>
      <OrganizationRecipientForm />
    </>
  );
}

export default OrgRecipientsFormView;
